var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShow = function SvgShow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.849 7.7C22.495 3.107 17.835 0 12.5 0 7.164 0 2.503 3.11.151 7.7a1.404 1.404 0 0 0 0 1.267c2.354 4.592 7.013 7.7 12.349 7.7 5.335 0 9.997-3.11 12.349-7.7a1.404 1.404 0 0 0 0-1.267ZM12.5 14.583a6.25 6.25 0 1 1 0-12.499 6.25 6.25 0 0 1 0 12.5Zm0-10.416c-.372.005-.741.06-1.098.164a2.077 2.077 0 0 1-2.904 2.904A4.157 4.157 0 1 0 12.5 4.167Z",
    fill: "#fff"
  })));
};
export default SvgShow;